// EXCEPTIONS OBJECTS 
	
	// Exception that will be thrown, when user trying to add product with same id few times
		function ProductExistInCompareException(message) {
		    this.message = message;
		    // Use V8's native method if available, otherwise fallback
		    if ("captureStackTrace" in Error)
		        Error.captureStackTrace(this, ProductExistInCompareException);
		    else
		        this.stack = (new Error()).stack;
		}

		ProductExistInCompareException.prototype = Object.create(Error.prototype);
		ProductExistInCompareException.prototype.name = "ProductExistInCompareException";
		ProductExistInCompareException.prototype.constructor = ProductExistInCompareException;

	// Exception that will be thrown, when user trying to add more then 4 products in compare
		function MaximumProductsInCompareException(message) {
		    this.message = message;
		    // Use V8's native method if available, otherwise fallback
		    if ("captureStackTrace" in Error)
		        Error.captureStackTrace(this, MaximumProductsInCompareException);
		    else
		        this.stack = (new Error()).stack;
		}

		MaximumProductsInCompareException.prototype = Object.create(Error.prototype);
		MaximumProductsInCompareException.prototype.name = "MaximumProductsInCompareException";
		MaximumProductsInCompareException.prototype.constructor = MaximumProductsInCompareException;


// Compare Functional

	// Open compare popup (animation from bottom)
		var compareCloseBlockTimeout;
		var compareCloseTimeout;
		function openCompareBlock(){
			clearTimeout(compareCloseTimeout);
			clearTimeout(compareCloseBlockTimeout);
			jQuery('#open-compare-block-hover-line').css('bottom', '-45px');
			jQuery('#compare-products-block').css('display', 'block');

			setTimeout(function(){
				jQuery('#compare-products-block').css('bottom', '-2px');
				jQuery.cookie('compareProductsBlockStatus', 'opened', { expires: 7, path: '/' });
			}, 200);
		}

	// Close compare popup (animation to bottom)
		function closeCompareBlock(showLinkToComparePopup){
			jQuery('#compare-products-block').css('bottom', '-101%');
			compareCloseTimeout = setTimeout(function(){
				if(showLinkToComparePopup){
					jQuery('#open-compare-block-hover-line').css('bottom', '');
					jQuery('#open-compare-block-hover-line').removeClass('closed');
					jQuery.cookie('compareProductsBlockStatus', 'hidden', { expires: 7, path: '/' });
				}else{
					jQuery.cookie('compareProductsBlockStatus', 'closed', { expires: 7, path: '/' });
				}
			}, 350);

			compareCloseBlockTimeout = setTimeout(function(){
				jQuery('#compare-products-block').css('display', 'none');
			}, 1200);
		}

	// Delete product from compare by ID 
		function removeProductFromCompare(id, closeIfLastProduct){
			var productBlock = jQuery('.product-to-compare-container[data-product-id="' + id + '"]');

			// Do animation for desktop and tablets
			if(window.innerWidth >= 768){
				jQuery(productBlock).find('.top-title').css('opacity', 0);
				jQuery(productBlock).find('.remove-product').css('opacity', 0);
				jQuery(productBlock).addClass('noAfterShadow noBorder');
				setTimeout(function(){
				jQuery(productBlock).css({
						'top':'-200px'
					});
				}, 250);
				setTimeout(function(){
					jQuery(productBlock).css({
						'width' : '0px',
						'margin' : '0px'
					});
				}, 500);
				setTimeout(function(){
					jQuery(productBlock).remove();
				}, 1200);
			}else{
				// Or just remove product with data for mobiles
				jQuery(productBlock).remove();
			}
			

			if(jQuery.cookie('compareProducts').split(',').length == 2 && closeIfLastProduct == true){
				closeCompareBlock();
			}

			if(jQuery.cookie('compareProducts').split(',').length == 3){
				removeProductSectionRow(id);
				jQuery('.remove-product-row').hide();
			}else{
				//Remove Section on compare result page
				removeProductSectionRow(id);
			}



			var cookieIdSet = jQuery.cookie('compareProducts');
			var newCookieIdSet = cookieIdSet.replace(id + ',','');
			jQuery('.compare-toggle-link[data-product-id=' + id + ']').find('.compare-toggle-icon').removeClass('icon-in-compare').addClass('icon-add-to-compare');
			jQuery.cookie('compareProducts', newCookieIdSet, { expires: 7, path: '/' });
			
		}

		function removeProductSectionRow(id){
			if(window.location.href.indexOf('compare?products') > -1){

				if(jQuery.cookie('compareProducts').split(',').length > 2){
					jQuery('.vertical-row[data-row-id=' + id + ']').remove();
					var currentUrl = window.location.href;
					var index = currentUrl.indexOf('compare?products');
					var id_array = currentUrl.substr(index);
					var new_id_array = id_array.replace(id + ',', '');

					var new_url = currentUrl.replace(id_array, new_id_array);

					window.history.pushState("ZipHearing", "ZipHearing Compare", new_url);
				}
				
			}
		}

	// Function called from different pages (hearing aid, product), gives an HTML object that called this function in parameter, to update status of compare link
		var tooltipCloseTimeout;
		function compareToggle(compareLink){
			var currentProductId = jQuery(compareLink).attr('data-product-id');

			try{
				if(addNewProductToCompareBlock(currentProductId)){
					if(window.innerWidth >= 768){
						openCompareBlock();
					}else{
						closeCompareBlock(true);
					}
					
					console.log(compareLink);
					console.log(jQuery(compareLink).find('.compare-toggle-icon'));
					jQuery(compareLink).find('.compare-toggle-icon').removeClass('icon-add-to-compare').addClass('icon-in-compare');
				}
			}catch(exception){
				if(exception instanceof ProductExistInCompareException){
					console.log('Catched ProductExistInCompareException');

					openCompareBlock();

					if(window.innerWidth >= 768){
						jQuery('.product-to-compare-container[data-product-id=' + currentProductId + ']').addClass('hover');
						setTimeout(function(){
							jQuery('.product-to-compare-container[data-product-id=' + currentProductId + ']').removeClass('hover');
						}, 3000);
					}
					
				}else if(exception instanceof MaximumProductsInCompareException){
					clearTimeout(tooltipCloseTimeout);
					console.log('Catched  MaximumProductsInCompareException');

					if(window.innerWidth >= 768){
						openCompareBlock();
					}
					
					jQuery(compareLink).find('.compare-toggle-icon').tooltip('show');
					tooltipCloseTimeout = setTimeout(function(){
						jQuery(compareLink).find('.compare-toggle-icon').tooltip('hide');
					}, 2000);
				}
			}
			
		}

	// Delete all products from compare and close popup
		function clearAll(){
			var productsToCompareSet = jQuery('#compare-products-block .selected-products-container .product-to-compare-container[data-product-id]');

			var i = 0;

			if(window.innerWidth >= 768){
				var animationInterval = setInterval(function(){
					if(i < productsToCompareSet.length){
						var productId = jQuery(productsToCompareSet[i]).attr('data-product-id');
						removeProductFromCompare(productId, false);
						i++;
					}else{
						clearInterval(animationInterval);
						setTimeout(function(){
							closeCompareBlock(false);
							jQuery.cookie('compareProducts', '', { expires: 7, path: '/' });
							console.log('All Products Removed from compare, compare popup closed');
						}, 800);
					}
				}, 150);
			}else{
				closeCompareBlock(false);

				for(var i = 0; i < productsToCompareSet.length; i++){
					var productId = jQuery(productsToCompareSet[i]).attr('data-product-id');
					removeProductFromCompare(productId, false);
				}

				jQuery.cookie('compareProducts', '', { expires: 7, path: '/' });
				console.log('All Products Removed from compare, compare popup closed');
			}
			
		}

	jQuery(document).on('touchstart', '.overflow-product-image-container', function(e){
		console.log('Compare prevent.');
		e.preventDefault();
		jQuery('.product-to-compare-container').removeClass('hover');
		jQuery(this).parent('.product-to-compare-container').addClass('hover');
	});

	jQuery('#compare-products-block').click(function(){
		jQuery('.product-to-compare-container').removeClass('hover');
	});



	// Add new product to compare by ID
	// MOVED TO components/compare.php view, because of php csrf protection